import { Divider, Stack } from '@mui/material'

import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { useAppSelector } from 'store/hooks'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { BaseWidget } from '../../baseWidget'

export const FeedConsumptionWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_food_table || error) return null

	const distributed = statistics?.distribution?.total
	const leftover = statistics?.cleaning?.total

	return (
		<BaseWidget
			path={'/analytics/feeding'}
			isLoading={loading}
			pathLable='Перейти в аналитику кормления'
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='column' gap='4px'>
					{(distributed || distributed === 0) && (
						<Stack direction='row' alignItems='baseline' gap='4px'>
							<TypographyPrimary16Bold>{distributed}</TypographyPrimary16Bold>
							<TypographySecondary>кг</TypographySecondary>
						</Stack>
					)}
					<TypographyPrimary>Роздано корма</TypographyPrimary>
				</Stack>

				<Divider />

				<Stack direction='column' gap='4px'>
					{(leftover || leftover === 0) && (
						<Stack direction='row' alignItems='baseline' gap='4px'>
							<TypographyPrimary16Bold>{leftover}</TypographyPrimary16Bold>
							<TypographySecondary>кг</TypographySecondary>
						</Stack>
					)}
					<TypographyPrimary>Остаток</TypographyPrimary>
				</Stack>
			</Stack>
		</BaseWidget>
	)
}
